import request from "@/api/axios";

//快捷登录
export function captcha(data) {
	return request({
		url: `/login/captcha`,
		method: 'post',
		data
	});
}
//密码登录
export function passWordLogin(data) {
	return request({
		url: `/login/password`,
		method: 'post',
		data,
	});
}
//发送验证码
export function sendSmSCode(params) {
	return request({
		url: `/login/sendcaptcha`,
		method: 'get',
		params
	});
}
//忘记密码
export function findPassword(data) {	
	return request({
		url: `/login/register`,
		method: 'post',
		data
	});
}
//校验手机是否注册过
export function checkMobile(params) {
	return request({
		url: `/login/checkmobile`,
		method: 'get',
		params
	});
}